// @flow
import type {Tracking} from "../../models/Tracking";
import GoogleBaseTracker from "./GoogleBaseTracker";

export default class GTMTracker extends GoogleBaseTracker implements Tracking {
    constructor(trackingIds: string[], withEcommerce: boolean = false, dealerId: string = "unknown", dealerName: string = "unknown", customerNo: string = "unknown") {
        super(trackingIds[0], withEcommerce);

        if (navigator.doNotTrack === "1") {
            window[`ga-disable-${this.trackingId}`] = true;
            return;
        }

        this.injectGtag(this.trackingId, dealerId, dealerName, customerNo);
    }

    injectGtag(configId: string, dealerId: string, dealerName: string, customerNo: string) {
        const existing = document.querySelector(`script[src*="gtag/js?id=${configId}"]`);
        if (!existing) {
            const script = document.createElement("script");
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(configId)}`;
            document.head.appendChild(script);
        }

        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function gtag() {
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
        };

        window.gtag("js", new Date());
        // page views use Google's default behaviour (automatic initial page_view;
        // in-module navigation via Enhanced Measurement in the GA4 property)
        window.gtag("config", configId, {
            dealerId: dealerId,
            dealerName: dealerName,
            customerNo: customerNo
        });
    }

    send(eventName: string, payload: ?{}) {
        if (window && window.gtag) {
            window.gtag("event", eventName, payload);
        }
    }
}
